// extracted by mini-css-extract-plugin
export default {"list":"style_list__h64tG","item":"style_item__jHIw5"};